import { render, staticRenderFns } from "./peripheral_chart.config.vue?vue&type=template&id=67c54cba"
import script from "./peripheral_chart.config.vue?vue&type=script&lang=js"
export * from "./peripheral_chart.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports